import { Builder } from '@builder.io/react';

import { DataBox } from './index';

Builder.registerComponent(DataBox, {
  name: 'DataBox',
  inputs: [
    { name: 'title', type: 'string', defaultValue: 'title' },
    { name: 'subtitle', type: 'string', defaultValue: 'subtitle' },
    {
      name: 'body',
      type: 'string',
      defaultValue:
        'Scale has pioneered in the data labeling industry by combining AI-based techniques with human-in-the-loop, delivering labeled data at unprecedented quality, scalability, and efficiency.'
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          defaultValue: [
            {
              text: 'Get Started',
              href: '/sales',
              type: 'primary'
            }
          ],
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'type',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary']
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'default',
              enum: ['default', 'transparent']
            }
          ]
        },
        {
          name: 'hubspotModal',
          type: 'object',
          subFields: [
            {
              name: 'formId',
              type: 'string'
            },
            {
              name: 'sfdcCampaignId',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            }
          ]
        }
      ]
    },
    {
      name: '3d',
      type: 'object',
      subFields: [{ name: 'label', type: 'string' }]
      // defaultValue: null
    },
    {
      name: 'image',
      type: 'object',
      subFields: [
        { name: 'label', type: 'string' },
        { name: 'url', type: 'file', allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'] },
        { name: 'alt', type: 'string' }
      ]
      // defaultValue: null
    },
    {
      name: 'video',
      type: 'object',
      subFields: [
        { name: 'label', type: 'string' },
        { name: 'url', type: 'string' },
        { name: 'poster', type: 'string' }
      ]
      // defaultValue: null
    },
    {
      name: 'mapping',
      type: 'object',
      subFields: [{ name: 'label', type: 'string' }]
      // defaultValue: null
    },
    {
      name: 'text',
      type: 'object',
      subFields: [{ name: 'label', type: 'string' }]
      // defaultValue: null
    },
    {
      name: 'audio',
      type: 'object',
      subFields: [{ name: 'label', type: 'string' }]
      // defaultValue: null
    }
  ]
});
